import './styles';

import React from 'react';
import _ from 'lodash';

import TruncatableText from 'details/components/truncatable_text';
import Badge from 'details/components/badge';

const INITIAL_VISIBLE_ROWS = 2;

export default class DocumentMetadata extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        return (
            <div className="DocumentMetadata">
                <div className="DocumentMetadata-Badge">
                    {this.props.publication.metricsLoaded && (
                        <Badge config={this.props.config} totalCitations={this.props.publication.totalCitations} />
                    )}
                </div>
                <div className="DocumentMetadata-Content">
                    <h1>{this.props.publication.title}</h1>
                    <div className="DocumentMetadata-Info">
                        <div className="DocumentMetadata-Table">
                            <table>
                                <tbody>{this.tableRows}</tbody>
                            </table>
                            {this.tableToggleLink}
                        </div>
                        <div className="DocumentMetadata-Links">
                            {this.publisherLink}
                            {this.usdaReferrerLink}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    get tableRows() {
        let allRows = this.rowsByPriority;
        return this.state.expanded ? allRows : allRows.slice(0, INITIAL_VISIBLE_ROWS);
    }

    get tableToggleLink() {
        if (!this.canExpand) return;

        let text = this.state.expanded ? 'Fewer details' : 'More details';

        return (
            <a
                className={`DocumentMetadata-toggle-button ${this.state.expanded ? 'expanded' : 'collapsed'}`}
                onClick={() => this.setState({ expanded: !this.state.expanded })}
            >
                {text}
            </a>
        );
    }

    get rowsByPriority() {
        return _.compact([
            this.publicationDataRow,
            this.authorsRow,
            this.doiRow,
            this.pubmedIdRow,
            this.dimensionsIdRow
        ]);
    }

    get canExpand() {
        return this.rowsByPriority.length > INITIAL_VISIBLE_ROWS;
    }

    get publicationDataRow() {
        let { publicationDate, journal } = this.props.publication;
        let date = publicationDate ? publicationDate.format('MMMM YYYY') : null;
        let content = <td />;
        let title;

        if (journal) {
            title = journal.title;
        }

        if (title && date) {
            content = (
                <td>
                    Article in <strong>{title}</strong>, published {date}
                </td>
            );
        } else if (title) {
            content = (
                <td>
                    Article in <strong>{title}</strong>
                </td>
            );
        } else if (date) {
            content = <td>Article published {date}</td>;
        }

        return (
            <tr key="publicationData">
                <th>Publication</th>
                {content}
            </tr>
        );
    }

    get authorsRow() {
        if (!this.props.publication.authorNames) return;

        return (
            <tr key="authors">
                <th>Authors</th>
                <td>
                    <TruncatableText text={this.props.publication.authorNames} />
                </td>
            </tr>
        );
    }

    get doiRow() {
        if (!this.props.publication.doi) return;

        return (
            <tr key="doi">
                <th>DOI</th>
                <td>
                    <a className="external-link" href={this.props.publication.doiURI} target="_blank">
                        {this.props.publication.doi}
                    </a>
                </td>
            </tr>
        );
    }

    get pubmedIdRow() {
        if (!this.props.publication.pmid) return;

        return (
            <tr key="pmid">
                <th>PubMed ID</th>
                <td>
                    <a className="external-link" href={this.props.publication.pubmedURI} target="_blank">
                        {this.props.publication.pmid}
                    </a>
                </td>
            </tr>
        );
    }

    get dimensionsIdRow() {
        if (!this.props.publication.id) return;

        return (
            <tr key="id">
                <th>Dimensions ID</th>
                <td>
                    <a className="external-link" href={this.props.publication.dimensionsURI} target="_blank">
                        {this.props.publication.id}
                    </a>
                </td>
            </tr>
        );
    }

    get publisherLink() {
        if (!this.props.publication.doi) {
            return;
        }

        return (
            <div className="DocumentMetadata-PublisherLink">
                <a href={this.props.publication.doiURI} target="_blank">
                    {I18n.t('buttons.view_on_publisher_site')}
                </a>
            </div>
        );
    }

    get usdaReferrerLink() {
        if (!document.referrer || document.referrer.indexOf('https://pubag.nal.usda.gov') < 0) {
            return null;
        }

        return (
            <div className="DocumentMetadata-UsdaReferrerLink">
                <a href={document.referrer} target="_blank">
                    {I18n.t('buttons.view_at_usda_pubag')}
                </a>
            </div>
        );
    }
}
